import { render, staticRenderFns } from "./speaker-list.vue?vue&type=template&id=18c3b3e9&scoped=true"
import script from "./speaker-list.vue?vue&type=script&lang=js"
export * from "./speaker-list.vue?vue&type=script&lang=js"
import style0 from "./speaker-list.vue?vue&type=style&index=0&id=18c3b3e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c3b3e9",
  null
  
)

export default component.exports